<template>
  <v-layout wrap justify-start align-center align-content-center>
    <v-flex xs3 style="max-width:200px;">
      <v-select :items="yearList" v-model="targetYearMonth.startYear" />
    </v-flex>
    <v-flex xs2 style="max-width:200px;" class="pl-2">
      <v-select
        v-if="!isdisabledStartMonth"
        :items="startMonthList"
        v-model="targetYearMonth.startMonth"
      />
    </v-flex>
    <v-flex xs1 style="text-align: center;">〜</v-flex>
    <v-flex xs3 style="max-width:200px;">
      <v-select :items="yearList" v-model="targetYearMonth.endYear" />
    </v-flex>
    <v-flex xs2 style="max-width:200px;">
      <v-select
        v-if="!isdisabledEndMonth"
        :items="endMonthList"
        v-model="targetYearMonth.endMonth"
        class="pl-2"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    targetYearMonth: {
      type: Object,
      default: () => {},
    },
    yearList: {
      type: Array,
      default: () => [],
    },
    startMonthList: {
      type: Array,
      default: () => [],
    },
    endMonthList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isdisabledStartMonth() {
      return this.targetYearMonth.startYear === null
    },
    isdisabledEndMonth() {
      return this.targetYearMonth.endYear === null
    },
  },
  watch: {
    'targetYearMonth.startYear'() {
      this.changeSelectableStartMonth()
    },
    'targetYearMonth.endYear'() {
      this.changeSelectableEndMonth()
    },
  },
  methods: {
    changeSelectableStartMonth() {
      if (this.targetYearMonth.startYear === null) {
        this.targetYearMonth.startMonth = null
        return
      }
      if (
        !this.startMonthList.some(
          month => month.value === this.targetYearMonth.startMonth,
        )
      ) {
        this.targetYearMonth.startMonth = this.startMonthList[0].value
      }
    },
    changeSelectableEndMonth() {
      if (this.targetYearMonth.endYear === null) {
        this.targetYearMonth.endMonth = null
        return
      }
      if (
        !this.endMonthList.some(
          month => month.value === this.targetYearMonth.endMonth,
        )
      ) {
        this.targetYearMonth.endMonth = this.endMonthList[
          this.endMonthList.length - 1
        ].value
      }
    },
  },
}
</script>
